import React from 'react';
import { experience } from '../data/resume';
import './Experience.css';

export default function Experience() {
  return (
    <section id="experience" className="section-wrap">
      <h2 className="section-title">Experience</h2>
      <div className="exp-grid">
        {experience.map((job) => (
          <div className="exp-card" key={job.company}>
            {job.featured && <div className="exp-badge">★ Featured</div>}
            <div className="exp-header">
              <div>
                <div className="exp-role">{job.role}</div>
                <div className="exp-company mono">{job.company}</div>
              </div>
              <div className="exp-meta mono">
                {job.period}
                <br />
                {job.location}
              </div>
            </div>
            <ul className="exp-points">
              {job.points.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
